var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticStyle:{"border-bottom":"2px solid #5f5f5f !important"},attrs:{"color":"white","flat":"","height":"80"}},[_c('v-img',{staticClass:"mx-auto",attrs:{"src":_vm.imgLogo,"max-width":"200"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }